import React from 'react';
import {Box} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import {Avatar} from '@contentlab/api/avatars';
import translate from '@/utils/translate';

interface AiAvatarVideoTitleProps {
  hasGeneratedScripts: boolean;
  selectedAvatar: Avatar | null;
  fallbackName?: string;
}

/**
 * Component that renders the video title for AI Avatar page
 * based on script generation state and selected avatar.
 */
function AiAvatarVideoTitle({
  hasGeneratedScripts,
  selectedAvatar,
  fallbackName = '',
}: AiAvatarVideoTitleProps) {
  if (hasGeneratedScripts && selectedAvatar) {
    return (
      <Box component="span" style={{display: 'inline'}}>
        <Box component="span" style={{fontWeight: 600}}>
          {translate('Voiceover Preview')}
        </Box>
        <Box component="span" style={{fontSize: '0.85em', margin: '0 6px'}}>
          ·
        </Box>
        <Box component="span" style={{fontWeight: 400}}>
          {selectedAvatar.name}
        </Box>
      </Box>
    );
  }

  return fallbackName;
}

interface AiAvatarVideoSubtitleProps {
  hasGeneratedScripts: boolean;
  selectedAvatar: Avatar | null;
}

/**
 * Component that renders the video subtitle for AI Avatar page
 * when scripts have been generated.
 */
function AiAvatarVideoSubtitle({
  hasGeneratedScripts,
  selectedAvatar,
}: AiAvatarVideoSubtitleProps) {
  if (hasGeneratedScripts && selectedAvatar) {
    return (
      <Body
        size="lg"
        color={designSystemToken('semantic.fg.inverse-secondary')}
      >
        {translate('Avatar will go live after generation')}
      </Body>
    );
  }

  return null;
}

export {AiAvatarVideoTitle, AiAvatarVideoSubtitle};
